module.exports = __webpack_public_path__ + "img/Snorre_Moster_Kirke.0bc1a047.jpg";